import type { FormParams, PartialRecordError } from '@/types/Form';
import { useVuelidate } from '@vuelidate/core';
import { ref } from 'vue';

export function useForm<FormData>({ form, rules }: FormParams<FormData>) {
  const formData = ref<FormData>(form);

  const v$ = useVuelidate(rules, formData, { $autoDirty: true, $scope: false });

  const handleSubmit = async (callback: () => Promise<any> | void) => {
    const result = await v$.value.$validate();
    if (!result) return;
    return await callback();
  };

  const getErrors = (otherErrors?: PartialRecordError<FormData>) => {
    return $parsedError<FormData>(formData.value, v$, otherErrors);
  };

  return {
    v$,
    form: formData,
    handleSubmit,
    getErrors,
  };
}
